module.exports = __webpack_public_path__ + "static/img/icon-long-outstanding.609514c2.svg";